import { makeObservable, observable, computed, action } from 'mobx';
import { TFilterAbstract } from '@features/categories/typescript';
export default class FilterState {
  type = '';
  name = '';
  key = '';
  userActivity = false;
  constructor(filter: TFilterAbstract) {
    makeObservable(this, {
      type: observable,
      name: observable,
      key: observable,
      userActivity: observable,
      queryName: computed,
      markUserActivity: action
    });
    this.type = filter.type;
    this.name = filter.name;
    this.key = filter.code.toLowerCase();
  }
  get queryName(): string {
    return `filter.${this.key}`;
  }
  markUserActivity() {
    this.userActivity = true;
  }
}